import { gql } from "generated-graphql";

export const GET_STAFF_CERS_SUBMITTALS = gql(`
  query StaffCersSubmittals($search: String, $page: Int, $pageSize: Int, $sort: [SortModel!]) {
    staffCersSubmittals(search: $search, page: $page, pageSize: $pageSize, sort: $sort) {
      items {
        id
        cersFacilityId
        organizationName
        facilityName
        siteAddress
        city
        zipCode
        localRegulatorDistrict
        submittedDate
        submittedBy
        moduleDecisions { id module status decisionDate cupaCode rawComment regulatorName regulatorEmail regulatorPhone }
      }
      count
    }
  }
`);
